import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import ProjectSectionHeader from './SectionHeader';
import AurPill from '../../common/aur-pill/AurPill';
import {IconColors, IconNames} from '../../common/aur-icon/AurIcon';

const stringPath = 'clientDetailsPage.projectDrawer.ecaDatabase.';

interface Props {
  enableNLP: boolean;
  enableEarlyCaseAssessment: boolean;
}

const ECADatabaseSection: React.FC<Props> = ({
  enableNLP,
  enableEarlyCaseAssessment,
}) => {
  const renderInfo = (title: string, enabled: boolean) => {
    return (
      <Box className="infoContainer">
        <Typography className="typo-text subhead4_size text">
          {t(title)}
        </Typography>
        <AurPill
          label={
            enabled ? t(stringPath + 'enabled') : t(stringPath + 'disabled')
          }
          icon={IconNames.Circle}
          iconSize="small"
          iconColor={enabled ? IconColors.Success : IconColors.Warning}
        />
      </Box>
    );
  };
  return (
    <Box className="ecaDatabaseSection">
      <ProjectSectionHeader headerText={t(stringPath + 'title')} />
      <Box className="contentContainer">
        {renderInfo(
          stringPath + 'earlyCaseAssessment',
          enableEarlyCaseAssessment
        )}
        {renderInfo(stringPath + 'nlpSearching', enableNLP)}
      </Box>
    </Box>
  );
};

export default ECADatabaseSection;
